import React from 'react';
import { observer } from 'mobx-react-lite';
import { Window, WindowHeader } from '../overlays';
import { RetryJobWindowState } from './retryJobWindowState';
import { Button } from '../input';

type Props = {
  model: RetryJobWindowState;
  visible?: boolean;
};

export const RetryJobWindow = observer((props: Props) => {
  const { model } = props;

  return (
    <Window
      model={model.window}
      visible={props.visible}
      isLoading={model.isLoading}>
      <WindowHeader model={model.window} title="Retry Job" />

      <hr />

      <div className="window-content">
        <p className="p-bold">Are you sure you want to retry processing this video?</p>
        <p>This will delete all moments and restart the processing pipeline. The original recording will be preserved.</p>
        {model.sourceType === 'Url' && (
          <label className="checkbox-label" style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '12px' }}>
            <input
              type="checkbox"
              checked={model.forceRedownload}
              onChange={(e) => (model.forceRedownload = e.target.checked)}
            />
            Re-download video from source URL
          </label>
        )}
      </div>

      <hr />

      <footer className="window-footer">
        <div className="btn-group right">
          <Button
            className="primary btn-outline medium"
            label="Cancel"
            onClick={() => model.close()}
          />
          <Button
            className="primary medium"
            label="Retry"
            onClick={() => model.submit()}
          />
        </div>
      </footer>
    </Window>
  );
});
